import Component from '../abstracts/Component';
import 'jquery';
import {AVAILABLE_BILLING_TYPES, IS_CHINA} from "../utils/Environment";


export default class AskInvoiceComponent extends Component {
  get SELECTORS() {
    return {
      form: '#ask-invoice',
      submitButton: '#submit-invoice',
      close: '.ask-invoice-modal #close',
      successBox: '#invoice-success',
      errorBox: '#invoice-error',
      askInvoiceButton: '.order-header_askinvoice[data-order]',
      billingAddresses: '.addresses.billing'
    };
  }

  render() {

    var button = $(this.SELECTORS.billingAddresses).find('.cta');

    if (AVAILABLE_BILLING_TYPES.valueOf() === 0) {
      button.addClass('disabled');
    }

    const {close,submitButton,errorBox,successBox,form,askInvoiceButton} = this.SELECTORS;
    $(document).on('submit',form,function (e){
      e.preventDefault();
      e.stopPropagation();
      const el = $(this);
      const billing= $('#js-billing-type',el)
      const hasBilling = (billing.val()||'').length>0;
      if (hasBilling) {
        $("#billingAddress\\.customerBillingType\\.error").addClass('d-none')
      } else {
        $("#billingAddress\\.customerBillingType\\.error").removeClass('d-none')
      }

      if(el.valid() & hasBilling) {
        const code = $(askInvoiceButton).data("order")
        $.ajax({
          method: 'post',
          url: "/action/ajax/ask-invoice/" + code + "?" + $(el).serialize(),
          success: function () {
            $(successBox).removeClass('d-none');
            $(el).closest('.vex-content').addClass('result')
            $(el).addClass('d-none');
            $(askInvoiceButton).attr('disabled',true)
          },
          error: function () {
            $(errorBox).removeClass('d-none');
            $(el).closest('.vex-content').addClass('result')
            $(el).addClass('d-none');
          },
        });
      }
    })



    let currentBillingVal = '';
    let oldBillingValue = currentBillingVal;

    setInterval(()=>{
      let billing= $('#js-billing-type')
      currentBillingVal = billing.val() || '';
      if(currentBillingVal !== oldBillingValue ){
        oldBillingValue = currentBillingVal
        const isCorporation = "CORPORATION"===currentBillingVal;

        const $fiscalCodeLabel = this.getFiscalCodeLabel();
        const $fiscalCodeVariantLabel = this.getFiscalCodeLabelVariant()

        if(isCorporation){
          $fiscalCodeLabel.addClass('d-none')
          $fiscalCodeVariantLabel.removeClass('d-none')
        }else{
          $fiscalCodeVariantLabel.addClass('d-none')
          $fiscalCodeLabel.removeClass('d-none')
        }

        if (currentBillingVal.length > 0) {
          $("#billingAddress\\.customerBillingType\\.error").addClass('d-none')
        } else {
          $("#billingAddress\\.customerBillingType\\.error").removeClass('d-none')
        }
      }
    },500)

    $(document).on('click',close,(e)=>{
      e.preventDefault();
      e.stopPropagation();
      $('.vex-close').trigger('click');
    })

  }
  getFiscalCodeLabel() {
    return this.getFirstElementAvailable('billingAddress.fiscalCode.label', 'address.fiscalCode.label')
  }
  getFiscalCodeLabelVariant() {
    return this.getFirstElementAvailable('billingAddress.fiscalCode.labelVariant','address.fiscalCode.labelVariant' )
  }
  getFirstElementAvailable(id1, id2) {
    let $element = $("[id='" + id1 + "']");
    if ($element.length == 0) {
      $element = $("[id='" + id2 + "']");
    }
    return $element;
  }
}
